// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"VideoNewRecord_bgVideoWrapper__HCOk-"};